<template>
  <div style="padding-top:56px;">
    <div>
      <h2 style="font-size:24px;">{{csymbol.toUpperCase()}}</h2>
      <div class='mylefttop'>
        <mu-select @change="onchange"  v-model="csymbol" full-width>
        <mu-option v-if="option.type=='小币种'"  v-for="option in options" :key="option.c1" :label="(option.c1+'/'+option.c2).toUpperCase()" :value="option.c1" ></mu-option>
      </mu-select>
      </div>
      <div class="columns is-mobile" style="margin-top:0;
  padding-top:0;">
        
        <div class="column">
          <div class="columns is-mobile">
            <div class="column">
             
              <mt-button @click="selectType('买入')" size="small" type="primary" plain>买入</mt-button>
            </div>
            <div class="column">
              <mt-button size="small" @click="selectType('卖出')" type="danger" plain>卖出</mt-button>
            </div>
           
          </div>
          <div class="inputcontainer">
           <div class="label">涨</div>
             <div class="label">价格</div>
           <NumberInput :value='cprice'  :step='1' :min='price-0.0005'   :max='price+0.0005' placeholder="价格" v-model="cprice" ref='priceinput' />
            <div class="numbertip">≈¥{{cprice|to8}}</div>
          </div>
          <div class="inputcontainer">
            <div class="label">跌</div>
             <div class="label">数量</div>
            <NumberInput :min='1' :max="100000" v-model='num' :step='1'/>
            <div class="numbertip" v-if="ctype=='买入'">可用{{user.balance | to8}} ¥</div>
            <div v-else class="numbertip">可用{{user.assets[csymbol].balance | to8}} {{csymbol.toUpperCase()}}</div>
            <div class='numbertip'>交易额 <strong>{{(cprice*num)| to8}}</strong></div>

          </div>
          <div v-if='false'>
            <mt-button>1/4</mt-button>
            <mt-button>1/2</mt-button>
            <mt-button>满仓</mt-button>
          </div>
         
        </div>
        <div class="column" style="padding-bottom:0px;">
          <div class="columns is-mobile">
            <div class="column priceitem">盘口</div>
            <div class="column priceitem">价格</div>
            <div class="column priceitem">数量</div>
          </div>
          <div class="columns is-mobile" v-for="item in [5,4,3,2,1]" :key="item+'s'">
            <div class="column priceitem red">{{item}}</div>
            <div class="column priceitem red">{{price+item*0.01 | to8}}</div>
            <div class="column priceitem">{{intarange(50,75)*500 | to8}}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column priceitem red">{{price|to8}}</div>
            <div class="column priceitem red">+{{up}}%</div>
          </div>

          <div class="columns is-mobile" v-for="item in [1,2,3,4,5]" :key="item+'1'">
            <div class="column priceitem green">{{item}}</div>
            <div class="column priceitem green">{{price-item*0.01 | to8}}</div>
            <div class="column priceitem">{{intarange(50,75)*500 | to8}}</div>
          </div>
          <div class="columns is-mobile">
            <div class="column priceitem green">{{price|to8}}</div>
            <div class="column priceitem green">+{{up}}%</div>
          </div>
        </div>
      </div>
       <div style="padding-bottom:10px;">
          <mt-button @click="buyorsell()" :disabled='isok()' type="primary" style="width:80%">{{ctype}}{{csymbol.toUpperCase()}}</mt-button>
          </div>
      <div class="columns is-mobile">
          <div class="column">当前委托</div>
          <div class="column">委托历史</div>
      </div>
      <div>
          <div>暂无记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import Util from '@/utils'
import NumberInput from '@/components/NumberInput'
export default {
  components:{
       NumberInput
  },
   data(){
     return {
        price:20.0,
        cprice:20.0,
        up:0.04,
        num:1,
        huilv:0.1414,
        symbol:'',
        csymbol:'hsbs',
        ctype:'买入',
        op:'hsbs',
        isloading:true,   
       
     }
   },
   computed:{
      options(){
          return this.$store.state.currencylist;
      },
      user(){
        return this.$store.state.user;
      },
      
     
   },
   filters: {
     to8(value){
       return Math.ceil(value).toFixed(2);
     }
   },
   mounted(){
      
       console.log('tradeview');
      
       if(this.$route.params.c){
         
         this.op=this.$route.params.c.replace("USDT","").toLowerCase()
         this.onchange(this.op)
         this.csymbol=this.op;
       }
       else {
         this.op='hsbs';
         this.onchange('hsbs')
         this.csymbol = 'hsbs'
       }
   },
   methods: {
     intarange(a,b){
       return Util.intarange(a,b);
     },
     selectType(b){
       this.ctype=b;
     },
     onchange(value){
       console.log(value);

       Api.getPrice(value).then((res)=>{
           this.price = res.data.close;
           this.cprice = res.data.close;
           setTimeout(()=>{
             this.$refs.priceinput.updateValue(res.data.close)
           },500)
           
           
       })
     },
     isok(){
        if(this.ctype=='买入'){
          return !this.isloading&&this.cprice*this.num>this.user.balance;
        }
        else{
          return !this.isloading&&this.user.assets[this.csymbol].balance<this.num;
        }
        
     },
     buyorsell(){
        this.isloading=true;
        this.$indicator.open({
        text: "提交中...",
        spinnerType: "fading-circle"
        });
        setTimeout(this.tr,2000);
     },
     tr(){
       if(this.ctype=='买入'){
         this.buy()
       }
       else {
         this.sell();
       }
     },
     buy(){
      
        Api.buy({price:this.cprice,number:this.num,tc:this.csymbol}).then(res => {
           this.$toast(res.data.message);
           this.$indicator.close();
           this.isloading=false;
           if(res.data.success){
                this.$store.dispatch("getUserInfo")
           }
           else {
            
           }
        })
     },
     sell(){
      
        Api.sell({price:this.cprice,number:this.num,tc:this.csymbol}).then(res => {
           this.$toast(res.data.message)
           if(res.data.success){
                this.$store.dispatch("getUserInfo")
           }
           else {
            
           }
          this.$indicator.close();
          this.isloading=false;
        })
     }
   }
};
</script>
<style scoped>
.myinput {
  height: 40px;
  border: #cccccc 1px solid;
  padding: 10px;
}
.inputcontainer {
  padding: 10px;
  text-align: left;
}
.numbertip {
  padding-top:10px;
  padding: 5px;
}
.red {
  color: tomato;
}
.green {
  color: green;
}
.priceitem {
  padding: 0.1rem;
  font-size: 0.6rem;
}

.columns {
  padding: 0.1rem;
  margin:0.1rem;

}
.column {
padding:0; 
}
.mu-input {
    font-size: 16px;
   
    min-height: 48px;
    display: inline-block;
    position: relative;
    color: rgba(0,0,0,.54);
   
    padding-top: 4px;
}
.mylefttop{
  text-align: left;
  font-size: 1.2rem;
  font-weight: bold;
  padding:20px;
  padding-top:5px;
  padding-bottom: 5px;
}
.jiaoyie{
  text-align: left;
  padding:10px 20px;
}

</style>


// WEBPACK FOOTER //
// src/pages/TradeView.vue